import React from 'react';
import { instagramPosts } from '../mockData';
import { Instagram } from 'lucide-react';

const InstagramSection = () => {
  return (
    <section className="instagram-section py-20 lg:py-32">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <span className="section-label">Follow Us</span>
          <h2 className="section-title mt-3 mb-4">
            <Instagram className="inline-block mr-3 text-gold" size={40} />
            @TasteT_Pistachio
          </h2>
          <p className="text-lg text-olive-dark">
            Join our pistachio family on Instagram! See our latest creations, behind-the-scenes baking, 
            and happy customers enjoying our treats.
          </p>
        </div>

        {/* Instagram Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 lg:gap-4">
          {instagramPosts.map(post => (
            <div key={post.id} className="instagram-post group">
              <img 
                src={post.image} 
                alt={post.caption}
                className="instagram-image"
              />
              <div className="instagram-overlay">
                <Instagram size={24} />
              </div>
            </div>
          ))}
        </div>

        {/* Follow CTA */}
        <div className="text-center mt-10">
          <a 
            href="https://instagram.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 cta-button-primary"
          >
            <Instagram size={20} />
            Follow Us on Instagram
          </a>
        </div>
      </div>
    </section>
  );
};

export default InstagramSection;
